__turbopack_context__.v({
  "card": "MakerCard-module-scss-module__E5GyPq__card",
  "icon": "MakerCard-module-scss-module__E5GyPq__icon",
  "image": "MakerCard-module-scss-module__E5GyPq__image",
  "moreCardWrapper": "MakerCard-module-scss-module__E5GyPq__moreCardWrapper",
  "title": "MakerCard-module-scss-module__E5GyPq__title",
  "titleWrapper": "MakerCard-module-scss-module__E5GyPq__titleWrapper",
});
